/**
 * Do not edit directly
 * Generated on Mon, 04 Sep 2023 12:53:22 GMT
 */

module.exports = {
  "base": {
    "color": {
      "scale": {
        "gray": {
          "0": {
            "value": "210 25% 98%",
            "dark": "210 67% 96%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "210 25% 98%",
              "dark": "210 67% 96%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "0"
            ]
          },
          "1": {
            "value": "210 24% 93%",
            "dark": "210 17% 82%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "210 24% 93%",
              "dark": "210 17% 82%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "1"
            ]
          },
          "2": {
            "value": "210 16% 85%",
            "dark": "212 14% 73%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "210 16% 85%",
              "dark": "212 14% 73%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "2"
            ]
          },
          "3": {
            "value": "210 13% 75%",
            "dark": "212 9% 58%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "210 13% 75%",
              "dark": "212 9% 58%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "3"
            ]
          },
          "4": {
            "value": "212 10% 62%",
            "dark": "215 8% 47%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "212 10% 62%",
              "dark": "215 8% 47%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "4"
            ]
          },
          "5": {
            "value": "210 8% 48%",
            "dark": "214 10% 31%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "210 8% 48%",
              "dark": "214 10% 31%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "5"
            ]
          },
          "6": {
            "value": "212 10% 38%",
            "dark": "212 12% 21%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "212 10% 38%",
              "dark": "212 12% 21%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "6"
            ]
          },
          "7": {
            "value": "212 11% 29%",
            "dark": "215 15% 15%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "212 11% 29%",
              "dark": "215 15% 15%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "7"
            ]
          },
          "8": {
            "value": "212 12% 22%",
            "dark": "215 21% 11%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "212 12% 22%",
              "dark": "215 21% 11%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "8"
            ]
          },
          "9": {
            "value": "213 13% 16%",
            "dark": "216 28% 7%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "213 13% 16%",
              "dark": "216 28% 7%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "gray",
              "9"
            ]
          }
        },
        "red": {
          "0": {
            "value": "4 100% 97%",
            "dark": "8 100% 92%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "4 100% 97%",
              "dark": "8 100% 92%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "0"
            ]
          },
          "1": {
            "value": "3 100% 91%",
            "dark": "6 100% 86%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "3 100% 91%",
              "dark": "6 100% 86%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "1"
            ]
          },
          "2": {
            "value": "2 100% 85%",
            "dark": "5 100% 80%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "2 100% 85%",
              "dark": "5 100% 80%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "2"
            ]
          },
          "3": {
            "value": "1 100% 76%",
            "dark": "4 100% 72%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "1 100% 76%",
              "dark": "4 100% 72%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "3"
            ]
          },
          "4": {
            "value": "359 95% 65%",
            "dark": "3 93% 63%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "359 95% 65%",
              "dark": "3 93% 63%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "4"
            ]
          },
          "5": {
            "value": "357 67% 50%",
            "dark": "1 69% 53%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "357 67% 50%",
              "dark": "1 69% 53%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "5"
            ]
          },
          "6": {
            "value": "356 71% 38%",
            "dark": "360 68% 43%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "356 71% 38%",
              "dark": "360 68% 43%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "6"
            ]
          },
          "7": {
            "value": "355 71% 30%",
            "dark": "358 74% 32%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "355 71% 30%",
              "dark": "358 74% 32%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "7"
            ]
          },
          "8": {
            "value": "354 74% 24%",
            "dark": "356 89% 21%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "354 74% 24%",
              "dark": "356 89% 21%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "8"
            ]
          },
          "9": {
            "value": "352 91% 17%",
            "dark": "0 95% 15%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "352 91% 17%",
              "dark": "0 95% 15%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "red",
              "9"
            ]
          }
        },
        "coral": {
          "0": {
            "value": "15 100% 96%",
            "dark": "15 100% 91%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "15 100% 96%",
              "dark": "15 100% 91%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "0"
            ]
          },
          "1": {
            "value": "12 100% 90%",
            "dark": "12 100% 85%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "12 100% 90%",
              "dark": "12 100% 85%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "1"
            ]
          },
          "2": {
            "value": "12 100% 82%",
            "dark": "12 100% 77%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "12 100% 82%",
              "dark": "12 100% 77%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "2"
            ]
          },
          "3": {
            "value": "11 97% 72%",
            "dark": "11 90% 68%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "11 97% 72%",
              "dark": "11 90% 68%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "3"
            ]
          },
          "4": {
            "value": "11 81% 60%",
            "dark": "10 80% 59%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "11 81% 60%",
              "dark": "10 80% 59%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "4"
            ]
          },
          "5": {
            "value": "9 64% 47%",
            "dark": "9 64% 49%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "9 64% 47%",
              "dark": "9 64% 49%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "5"
            ]
          },
          "6": {
            "value": "9 70% 36%",
            "dark": "8 69% 40%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "9 70% 36%",
              "dark": "8 69% 40%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "6"
            ]
          },
          "7": {
            "value": "8 79% 28%",
            "dark": "7 76% 30%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "8 79% 28%",
              "dark": "7 76% 30%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "7"
            ]
          },
          "8": {
            "value": "7 91% 22%",
            "dark": "6 92% 20%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "7 91% 22%",
              "dark": "6 92% 20%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "8"
            ]
          },
          "9": {
            "value": "6 98% 16%",
            "dark": "5 97% 14%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "6 98% 16%",
              "dark": "5 97% 14%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "coral",
              "9"
            ]
          }
        },
        "orange": {
          "0": {
            "value": "28 100% 95%",
            "dark": "34 100% 86%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "28 100% 95%",
              "dark": "34 100% 86%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "0"
            ]
          },
          "1": {
            "value": "28 100% 85%",
            "dark": "33 100% 75%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "28 100% 85%",
              "dark": "33 100% 75%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "1"
            ]
          },
          "2": {
            "value": "27 100% 74%",
            "dark": "28 100% 67%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "27 100% 74%",
              "dark": "28 100% 67%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "2"
            ]
          },
          "3": {
            "value": "25 96% 63%",
            "dark": "25 86% 59%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "25 96% 63%",
              "dark": "25 86% 59%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "3"
            ]
          },
          "4": {
            "value": "24 76% 51%",
            "dark": "23 71% 51%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "24 76% 51%",
              "dark": "23 71% 51%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "4"
            ]
          },
          "5": {
            "value": "24 100% 37%",
            "dark": "21 73% 43%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "24 100% 37%",
              "dark": "21 73% 43%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "5"
            ]
          },
          "6": {
            "value": "23 100% 29%",
            "dark": "20 76% 35%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "23 100% 29%",
              "dark": "20 76% 35%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "6"
            ]
          },
          "7": {
            "value": "22 100% 23%",
            "dark": "19 84% 25%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "22 100% 23%",
              "dark": "19 84% 25%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "7"
            ]
          },
          "8": {
            "value": "22 100% 18%",
            "dark": "19 96% 18%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "22 100% 18%",
              "dark": "19 96% 18%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "8"
            ]
          },
          "9": {
            "value": "19 100% 14%",
            "dark": "19 100% 12%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "19 100% 14%",
              "dark": "19 100% 12%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "orange",
              "9"
            ]
          }
        },
        "yellow": {
          "0": {
            "value": "50 89% 89%",
            "dark": "46 86% 80%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "50 89% 89%",
              "dark": "46 86% 80%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "0"
            ]
          },
          "1": {
            "value": "48 87% 73%",
            "dark": "44 85% 66%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "48 87% 73%",
              "dark": "44 85% 66%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "1"
            ]
          },
          "2": {
            "value": "46 76% 60%",
            "dark": "42 74% 57%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "46 76% 60%",
              "dark": "42 74% 57%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "2"
            ]
          },
          "3": {
            "value": "44 65% 50%",
            "dark": "41 72% 48%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "44 65% 50%",
              "dark": "41 72% 48%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "3"
            ]
          },
          "4": {
            "value": "42 100% 37%",
            "dark": "40 91% 38%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "42 100% 37%",
              "dark": "40 91% 38%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "4"
            ]
          },
          "5": {
            "value": "40 100% 30%",
            "dark": "40 96% 32%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "40 100% 30%",
              "dark": "40 96% 32%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "5"
            ]
          },
          "6": {
            "value": "37 100% 24%",
            "dark": "37 91% 27%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "37 100% 24%",
              "dark": "37 91% 27%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "6"
            ]
          },
          "7": {
            "value": "36 98% 19%",
            "dark": "35 100% 21%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "36 98% 19%",
              "dark": "35 100% 21%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "7"
            ]
          },
          "8": {
            "value": "35 100% 15%",
            "dark": "33 100% 15%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "35 100% 15%",
              "dark": "33 100% 15%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "8"
            ]
          },
          "9": {
            "value": "34 90% 12%",
            "dark": "30 100% 10%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "34 90% 12%",
              "dark": "30 100% 10%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "yellow",
              "9"
            ]
          }
        },
        "lemon": {
          "0": {
            "value": "54 95% 85%",
            "dark": "54 100% 83%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "54 95% 85%",
              "dark": "54 100% 83%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "0"
            ]
          },
          "1": {
            "value": "52 87% 67%",
            "dark": "53 94% 67%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "52 87% 67%",
              "dark": "53 94% 67%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "1"
            ]
          },
          "2": {
            "value": "51 70% 56%",
            "dark": "52 73% 57%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "51 70% 56%",
              "dark": "52 73% 57%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "2"
            ]
          },
          "3": {
            "value": "50 72% 45%",
            "dark": "52 82% 42%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "50 72% 45%",
              "dark": "52 82% 42%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "3"
            ]
          },
          "4": {
            "value": "50 98% 33%",
            "dark": "52 100% 33%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "50 98% 33%",
              "dark": "52 100% 33%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "4"
            ]
          },
          "5": {
            "value": "49 100% 26%",
            "dark": "51 100% 27%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "49 100% 26%",
              "dark": "51 100% 27%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "5"
            ]
          },
          "6": {
            "value": "48 100% 20%",
            "dark": "50 100% 22%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "48 100% 20%",
              "dark": "50 100% 22%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "6"
            ]
          },
          "7": {
            "value": "47 100% 16%",
            "dark": "48 100% 17%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "47 100% 16%",
              "dark": "48 100% 17%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "7"
            ]
          },
          "8": {
            "value": "46 100% 13%",
            "dark": "46 100% 12%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "46 100% 13%",
              "dark": "46 100% 12%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "8"
            ]
          },
          "9": {
            "value": "43 100% 10%",
            "dark": "43 100% 8%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "43 100% 10%",
              "dark": "43 100% 8%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lemon",
              "9"
            ]
          }
        },
        "lime": {
          "0": {
            "value": "75 86% 85%",
            "dark": "75 74% 76%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "75 86% 85%",
              "dark": "75 74% 76%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "0"
            ]
          },
          "1": {
            "value": "76 75% 70%",
            "dark": "76 62% 64%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "76 75% 70%",
              "dark": "76 62% 64%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "1"
            ]
          },
          "2": {
            "value": "76 59% 58%",
            "dark": "77 54% 53%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "76 59% 58%",
              "dark": "77 54% 53%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "2"
            ]
          },
          "3": {
            "value": "77 51% 48%",
            "dark": "78 54% 45%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "77 51% 48%",
              "dark": "78 54% 45%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "3"
            ]
          },
          "4": {
            "value": "78 57% 38%",
            "dark": "79 60% 37%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "78 57% 38%",
              "dark": "79 60% 37%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "4"
            ]
          },
          "5": {
            "value": "80 64% 29%",
            "dark": "81 69% 30%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "80 64% 29%",
              "dark": "81 69% 30%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "5"
            ]
          },
          "6": {
            "value": "82 66% 22%",
            "dark": "83 75% 23%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "82 66% 22%",
              "dark": "83 75% 23%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "6"
            ]
          },
          "7": {
            "value": "84 85% 16%",
            "dark": "85 84% 17%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "84 85% 16%",
              "dark": "85 84% 17%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "7"
            ]
          },
          "8": {
            "value": "86 90% 12%",
            "dark": "89 90% 11%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "86 90% 12%",
              "dark": "89 90% 11%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "8"
            ]
          },
          "9": {
            "value": "88 96% 9%",
            "dark": "94 95% 7%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "88 96% 9%",
              "dark": "94 95% 7%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "lime",
              "9"
            ]
          }
        },
        "green": {
          "0": {
            "value": "133 80% 92%",
            "dark": "124 78% 82%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "133 80% 92%",
              "dark": "124 78% 82%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "0"
            ]
          },
          "1": {
            "value": "134 66% 80%",
            "dark": "125 69% 70%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "134 66% 80%",
              "dark": "125 69% 70%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "1"
            ]
          },
          "2": {
            "value": "135 62% 65%",
            "dark": "127 59% 58%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "135 62% 65%",
              "dark": "127 59% 58%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "2"
            ]
          },
          "3": {
            "value": "136 50% 53%",
            "dark": "128 49% 49%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "136 50% 53%",
              "dark": "128 49% 49%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "3"
            ]
          },
          "4": {
            "value": "137 57% 41%",
            "dark": "131 55% 40%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "137 57% 41%",
              "dark": "131 55% 40%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "4"
            ]
          },
          "5": {
            "value": "137 66% 30%",
            "dark": "132 59% 33%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "137 66% 30%",
              "dark": "132 59% 33%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "5"
            ]
          },
          "6": {
            "value": "138 71% 23%",
            "dark": "135 62% 26%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "138 71% 23%",
              "dark": "135 62% 26%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "6"
            ]
          },
          "7": {
            "value": "141 90% 16%",
            "dark": "138 69% 19%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "141 90% 16%",
              "dark": "138 69% 19%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "7"
            ]
          },
          "8": {
            "value": "142 100% 12%",
            "dark": "141 90% 12%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "142 100% 12%",
              "dark": "141 90% 12%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "8"
            ]
          },
          "9": {
            "value": "143 100% 9%",
            "dark": "139 81% 8%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "143 100% 9%",
              "dark": "139 81% 8%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "green",
              "9"
            ]
          }
        },
        "teal": {
          "0": {
            "value": "172 72% 92%",
            "dark": "173 59% 84%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "172 72% 92%",
              "dark": "173 59% 84%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "0"
            ]
          },
          "1": {
            "value": "173 58% 80%",
            "dark": "174 57% 71%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "173 58% 80%",
              "dark": "174 57% 71%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "1"
            ]
          },
          "2": {
            "value": "177 57% 63%",
            "dark": "176 53% 57%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "177 57% 63%",
              "dark": "176 53% 57%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "2"
            ]
          },
          "3": {
            "value": "177 46% 51%",
            "dark": "178 56% 45%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "177 46% 51%",
              "dark": "178 56% 45%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "3"
            ]
          },
          "4": {
            "value": "179 51% 41%",
            "dark": "178 58% 39%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "179 51% 41%",
              "dark": "178 58% 39%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "4"
            ]
          },
          "5": {
            "value": "180 66% 29%",
            "dark": "179 64% 31%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "180 66% 29%",
              "dark": "179 64% 31%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "5"
            ]
          },
          "6": {
            "value": "181 67% 23%",
            "dark": "181 68% 25%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "181 67% 23%",
              "dark": "181 68% 25%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "6"
            ]
          },
          "7": {
            "value": "182 95% 15%",
            "dark": "181 76% 18%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "182 95% 15%",
              "dark": "181 76% 18%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "7"
            ]
          },
          "8": {
            "value": "182 82% 13%",
            "dark": "181 84% 12%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "182 82% 13%",
              "dark": "181 84% 12%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "8"
            ]
          },
          "9": {
            "value": "182 80% 10%",
            "dark": "182 90% 8%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "182 80% 10%",
              "dark": "182 90% 8%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "teal",
              "9"
            ]
          }
        },
        "blue": {
          "0": {
            "value": "200 100% 95%",
            "dark": "206 100% 90%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "200 100% 95%",
              "dark": "206 100% 90%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "0"
            ]
          },
          "1": {
            "value": "203 100% 87%",
            "dark": "207 100% 82%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "203 100% 87%",
              "dark": "207 100% 82%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "1"
            ]
          },
          "2": {
            "value": "205 100% 77%",
            "dark": "208 100% 74%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "205 100% 77%",
              "dark": "208 100% 74%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "2"
            ]
          },
          "3": {
            "value": "208 100% 67%",
            "dark": "212 100% 67%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "208 100% 67%",
              "dark": "212 100% 67%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "3"
            ]
          },
          "4": {
            "value": "211 100% 58%",
            "dark": "215 98% 61%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "211 100% 58%",
              "dark": "215 98% 61%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "4"
            ]
          },
          "5": {
            "value": "212 92% 45%",
            "dark": "216 84% 52%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "212 92% 45%",
              "dark": "216 84% 52%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "5"
            ]
          },
          "6": {
            "value": "213 95% 36%",
            "dark": "217 84% 42%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "213 95% 36%",
              "dark": "217 84% 42%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "6"
            ]
          },
          "7": {
            "value": "214 96% 29%",
            "dark": "218 85% 33%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "214 96% 29%",
              "dark": "218 85% 33%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "7"
            ]
          },
          "8": {
            "value": "216 82% 24%",
            "dark": "219 80% 23%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "216 82% 24%",
              "dark": "219 80% 23%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "8"
            ]
          },
          "9": {
            "value": "217 89% 18%",
            "dark": "220 88% 16%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "217 89% 18%",
              "dark": "220 88% 16%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "blue",
              "9"
            ]
          }
        },
        "indigo": {
          "0": {
            "value": "229 100% 97%",
            "dark": "227 100% 93%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "229 100% 97%",
              "dark": "227 100% 93%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "0"
            ]
          },
          "1": {
            "value": "231 100% 92%",
            "dark": "230 100% 89%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "231 100% 92%",
              "dark": "230 100% 89%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "1"
            ]
          },
          "2": {
            "value": "232 100% 86%",
            "dark": "234 100% 84%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "232 100% 86%",
              "dark": "234 100% 84%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "2"
            ]
          },
          "3": {
            "value": "234 100% 80%",
            "dark": "236 100% 79%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "234 100% 80%",
              "dark": "236 100% 79%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "3"
            ]
          },
          "4": {
            "value": "234 100% 73%",
            "dark": "238 91% 73%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "234 100% 73%",
              "dark": "238 91% 73%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "4"
            ]
          },
          "5": {
            "value": "237 84% 64%",
            "dark": "238 83% 65%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "237 84% 64%",
              "dark": "238 83% 65%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "5"
            ]
          },
          "6": {
            "value": "238 61% 53%",
            "dark": "237 60% 55%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "238 61% 53%",
              "dark": "237 60% 55%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "6"
            ]
          },
          "7": {
            "value": "237 58% 41%",
            "dark": "237 54% 43%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "237 58% 41%",
              "dark": "237 54% 43%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "7"
            ]
          },
          "8": {
            "value": "235 58% 32%",
            "dark": "235 61% 30%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "235 58% 32%",
              "dark": "235 61% 30%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "8"
            ]
          },
          "9": {
            "value": "235 57% 23%",
            "dark": "237 65% 21%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "235 57% 23%",
              "dark": "237 65% 21%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "indigo",
              "9"
            ]
          }
        },
        "purple": {
          "0": {
            "value": "285 100% 97%",
            "dark": "267 100% 94%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "285 100% 97%",
              "dark": "267 100% 94%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "0"
            ]
          },
          "1": {
            "value": "271 100% 92%",
            "dark": "270 100% 89%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "271 100% 92%",
              "dark": "270 100% 89%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "1"
            ]
          },
          "2": {
            "value": "267 100% 86%",
            "dark": "269 100% 83%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "267 100% 86%",
              "dark": "269 100% 83%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "2"
            ]
          },
          "3": {
            "value": "265 100% 80%",
            "dark": "265 100% 77%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "265 100% 80%",
              "dark": "265 100% 77%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "3"
            ]
          },
          "4": {
            "value": "261 92% 72%",
            "dark": "262 89% 71%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "261 92% 72%",
              "dark": "262 89% 71%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "4"
            ]
          },
          "5": {
            "value": "261 69% 59%",
            "dark": "261 73% 62%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "261 69% 59%",
              "dark": "261 73% 62%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "5"
            ]
          },
          "6": {
            "value": "261 53% 48%",
            "dark": "260 56% 52%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "261 53% 48%",
              "dark": "260 56% 52%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "6"
            ]
          },
          "7": {
            "value": "261 56% 38%",
            "dark": "261 52% 39%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "261 56% 38%",
              "dark": "261 52% 39%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "7"
            ]
          },
          "8": {
            "value": "261 59% 30%",
            "dark": "262 58% 28%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "261 59% 30%",
              "dark": "262 58% 28%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "8"
            ]
          },
          "9": {
            "value": "260 66% 23%",
            "dark": "261 67% 19%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "260 66% 23%",
              "dark": "261 67% 19%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "purple",
              "9"
            ]
          }
        },
        "pink": {
          "0": {
            "value": "330 100% 97%",
            "dark": "331 100% 93%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "330 100% 97%",
              "dark": "331 100% 93%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "0"
            ]
          },
          "1": {
            "value": "327 100% 91%",
            "dark": "331 100% 87%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "327 100% 91%",
              "dark": "331 100% 87%"
            },
            "name": "1",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "1"
            ]
          },
          "2": {
            "value": "327 100% 84%",
            "dark": "329 100% 80%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "327 100% 84%",
              "dark": "329 100% 80%"
            },
            "name": "2",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "2"
            ]
          },
          "3": {
            "value": "326 100% 75%",
            "dark": "329 89% 72%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "326 100% 75%",
              "dark": "329 89% 72%"
            },
            "name": "3",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "3"
            ]
          },
          "4": {
            "value": "325 76% 63%",
            "dark": "328 63% 62%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "325 76% 63%",
              "dark": "328 63% 62%"
            },
            "name": "4",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "4"
            ]
          },
          "5": {
            "value": "324 54% 49%",
            "dark": "327 48% 52%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "324 54% 49%",
              "dark": "327 48% 52%"
            },
            "name": "5",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "5"
            ]
          },
          "6": {
            "value": "323 59% 38%",
            "dark": "327 49% 42%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "323 59% 38%",
              "dark": "327 49% 42%"
            },
            "name": "6",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "6"
            ]
          },
          "7": {
            "value": "322 58% 30%",
            "dark": "326 55% 32%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "322 58% 30%",
              "dark": "326 55% 32%"
            },
            "name": "7",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "7"
            ]
          },
          "8": {
            "value": "320 67% 23%",
            "dark": "325 71% 22%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "320 67% 23%",
              "dark": "325 71% 22%"
            },
            "name": "8",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "8"
            ]
          },
          "9": {
            "value": "319 93% 16%",
            "dark": "324 83% 14%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "319 93% 16%",
              "dark": "324 83% 14%"
            },
            "name": "9",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "pink",
              "9"
            ]
          }
        },
        "black": {
          "0": {
            "value": "213 14% 12%",
            "dark": "218 80% 2%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "213 14% 12%",
              "dark": "218 80% 2%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "black",
              "0"
            ]
          }
        },
        "white": {
          "0": {
            "value": "0 100% 100%",
            "dark": "0 100% 100%",
            "filePath": "tokens/base/colors/color-scales.json",
            "isSource": true,
            "original": {
              "value": "0 100% 100%",
              "dark": "0 100% 100%"
            },
            "name": "0",
            "attributes": {},
            "path": [
              "base",
              "color",
              "scale",
              "white",
              "0"
            ]
          }
        }
      }
    }
  }
};
